import React from 'react';

import { Box, IconButton, Select, MenuItem, FormControl, InputLabel, Typography } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined';


function QuestionToolbar({
    data: criteriaData,
    onQVariableSelect,
    onShowHideAnswer,
    freeTextMode,
    onRemove,
    onUndo,
    onAdd,
    onEdit,
    onUpDown,
    index,
    answerHidden,
    editMode,
    selectedMode }) {



    const handleUpClick = () => onUpDown(-1);
    const handleDownClick = () => onUpDown(1);

    const changeQVariableSelected = (e) => {
        onQVariableSelect(JSON.parse(e.target.value), null, 'CONTEXT');
    }

    const clickShowHideAnswer = (e) => {
        onShowHideAnswer(e.target.id);
    }

    const clickUndo = (e) => {
        onUndo(e.target.id);
    }

    const clickAdd = (e) => {
        onAdd(e.target.id);
    }

    const clickRemove = (e) => {
        onRemove(e.target.id);
    }

    const clickEdit = (e) => {

        onEdit(e.target.id);
    }


    const generateSelectedContextQVariable = (contextQVariable) => {

        let contextQVariableClone = JSON.parse(JSON.stringify(contextQVariable));
        contextQVariableClone.imageQVariable = null;
        return JSON.stringify(contextQVariableClone);
    }


    const generateVariableSelect = () => {

        if (criteriaData.contextQVariableList) {

            var optionList = criteriaData.contextQVariableList.map((item) => {

                let itemLabel = item.label;

                return (<MenuItem key={itemLabel} value={JSON.stringify(item)} >
                    {itemLabel}
                </MenuItem>
                )
            });

            return (

                <FormControl sx={{ minWidth: 200, marginRight: '20px' }}>
                    <InputLabel id="context-label" size="small">Select</InputLabel>
                    <Select autoWidth label="Select" value={criteriaData.questionParams.contextQVariable ? generateSelectedContextQVariable(criteriaData.questionParams.contextQVariable) : ''} size='small' sx={{ backgroundColor: 'white' }} labelId='context-label' variant="outlined" onChange={changeQVariableSelected}>
                        {optionList}

                    </Select >
                </FormControl >
            )
        }

    }


    return (

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

            <Box>{selectedMode && <Typography variant="h3">{index + 1}</Typography>}</Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>

                {editMode && !freeTextMode && generateVariableSelect()}

                {editMode && !selectedMode && <IconButton aria-label="undo" size="small" onClick={clickUndo} ><UndoOutlinedIcon fontSize="large" /></IconButton>}

                <IconButton aria-label="edit" size="small" onClick={clickEdit} ><EditOutlinedIcon fontSize="large" /></IconButton>
                <IconButton aria-label="show/hide" size="small" onClick={clickShowHideAnswer}>{answerHidden ? <VisibilityOffOutlinedIcon fontSize="large" /> : <VisibilityOutlinedIcon fontSize="large" />}</IconButton>

                {selectedMode && <IconButton aria-label="up" size="small" onClick={handleUpClick}><ArrowCircleUpOutlinedIcon fontSize="large" /></IconButton>}
                {selectedMode && <IconButton aria-label="down" size="small" sx={{ marginLeft: '-10px' }} onClick={handleDownClick}><ArrowCircleDownOutlinedIcon fontSize="large" /></IconButton>}

                {!selectedMode && <IconButton aria-label="add" size="small" onClick={clickAdd}><AddCircleOutlinedIcon fontSize="large" color="success" /></IconButton>}
                {selectedMode && <IconButton aria-label="remove" size="small" onClick={clickRemove}><RemoveCircleOutlinedIcon fontSize="large" sx={{ color: 'red' }} /></IconButton>}

            </Box>



        </Box >

    )

}

export default QuestionToolbar;

